import { FeedItem } from '#components/Board/Section/Items/FeedItem';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import type { FeedTeaser } from '#domains/resolver/board-section-data';
import { TrackEventDataType } from '#types/tracking';
import { Tracktor } from 'react-tracktor';

type Props = {
	teaser: FeedTeaser;
	isLarge?: boolean;
	className?: string;
};

export function BoardSectionItemFeedItemTeaser({ teaser, className = '' }: Props) {
	const {
		constants: { appUrl },
	} = useEnvironment();

	if (teaser.type === 'empty') {
		return null;
	}

	return (
		<Tracktor
			trackingData={{
				data: {
					target: {
						title: teaser.title,
						url: `${appUrl}${teaser.href}`,
					},
					type: TrackEventDataType.BoardClick,
				},
			}}
		>
			{({ trackEvent }) => <FeedItem className={className} onClick={() => trackEvent({})} teaser={teaser} />}
		</Tracktor>
	);
}
